/**
 * Created by mac on 20.09.2026
 *
 * The strip a tutorial level keeps free for its dialogue. The away games reserve the bottom of the
 * scene while a tutorial scenario asks to raise the field, so the field inflates above it and the
 * tutorial's MinimalDialogue (POSITIONS.BOTTOM) lands in the strip instead of over the field.
 * Register it as an avoiding node: inflateComponent.addAvoidingNode(() => TutorialPlaceholder.create(node, heights)).
 */

const TutorialPlaceholder = {
    isNeeded() {
        return cleverapps.tutorial.scenarios.some((scenario) => scenario.options.needRaiseField && scenario.options.needRaiseField());
    },

    /**
     * @param {cc.Node} node the scene node the strip belongs to
     * @param {number[]} heights the strip height per resolution mode, in scene units
     * @returns {{getGlobalBoundingBox: function}|undefined} nothing outside a tutorial level
     */
    create(node, heights) {
        const height = this.isNeeded() && heights && heights[cleverapps.resolution.mode];
        if (!height) {
            return undefined;
        }

        return {
            getGlobalBoundingBox: () => {
                const bottomLeft = node.convertToWorldSpace(cc.p(0, 0));
                const topRight = node.convertToWorldSpace(cc.p(node.width, height));
                return cc.rect(bottomLeft.x, bottomLeft.y, topRight.x - bottomLeft.x, topRight.y - bottomLeft.y);
            }
        };
    }
};
